import { memo, useMemo } from 'react';

import { useHeaderOptions } from '../../model';
import FeaturedItem from '../FeaturedItem';

import { useWindowSize } from '@hooks/useWindowSize';
import type { MenuItem } from '@shared-types/menu.types';

const Featured = ({ item }: { item: MenuItem }) => {
  const { options } = useHeaderOptions();
  const { isMobile } = useWindowSize();

  const menuItems = useMemo(() => item?.menuItems.filter((m) => !m.customProperties?.hideOnMobile), [item?.menuItems]);

  if (!isMobile || options.isCompetitionContext) return null;

  return (
    <div className='pk-d--flex pk-justify-content--evenly pk-py--l pk-rounded--xl pk-bg--elevation-02'>
      {menuItems.map((m) => (
        <FeaturedItem key={m.id} item={m} />
      ))}
    </div>
  );
};

export default memo(Featured);
